module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"{name} :: แก้ไขข้อมูลบริษัท","page.description":"แก้ไขข้อมูลของบริษัท {name} ในระบบ","update_company.success":"ทำการแก้ไขข้อมูลบริษัท {name} ในระบบเรียบร้อย"}}')
  delete Component.options._Ctor
}
